<script setup lang="ts">
const { t } = useAppI18n()

const CLOSE_IMG = 'https://resources1.interface003.com/web30/2026/06/08/2af6f5ee-7ed0-4d4b-8dff-dcf5540ccb14.png'

const props = withDefaults(
  defineProps<{
    modelValue: boolean
    exchangeName?: string
    exchangeIco?: string
  }>(),
  {
    exchangeName: '',
  },
)

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const visible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

const closeDialog = () => {
  visible.value = false
}

const applyIbMessage = computed(() => {
  const message = t('已向{0}提交代理申请，申请结果将通过注册时的邮箱或电话进行通知，请耐心等待。')
  const [before, ...afterParts] = message.split('{0}')

  return {
    before,
    after: afterParts.join('{0}'),
  }
})
</script>

<template>
  <ElDialog
    v-model="visible"
    width="540px"
    align-center
    append-to-body
    :show-close="false"
    :close-on-click-modal="false"
    class="ib-apply-dialog"
  >
    <div class="overflow-hidden rounded-[28px] bg-[#fff]">
      <div class="flex flex-col bg-[#fff] px-[32px] pt-[32px]">
        <div class="flex w-full items-center gap-[8px] border-b-[0.5px] border-solid border-[#0515240f] pb-[16px]">
          <h2
            class="min-w-0 flex-1 overflow-hidden text-[20px] leading-[28px] font-[600] break-words text-ellipsis whitespace-nowrap text-[#292a2e]"
          >
            {{ t('成为代理商') }}
          </h2>
          <button
            type="button"
            class="flex size-[32px] shrink-0 cursor-pointer items-center justify-center rounded-[4px] hover:bg-[#f8f8f8]"
            @click="closeDialog"
          >
            <CommonImage :src="CLOSE_IMG" width="32" height="32" loading="eager" alt="" />
          </button>
        </div>
      </div>

      <div class="flex flex-col items-center bg-[#fff] px-[32px] pt-[20px] pb-[32px]">
        <p class="w-full text-[16px] leading-[24px] font-[400] break-words text-[#292a2e]">
          {{ applyIbMessage.before }}
          <span v-if="exchangeIco || exchangeName">
            <CommonImage
              v-if="exchangeIco"
              class="relative top-[-1px] mx-[2px] inline-block size-[18px] rounded-[3px] align-middle"
              :src="exchangeIco"
              :alt="exchangeName || 'exchange'"
              width="18"
              height="18"
            />
            <span v-if="exchangeName" class="mx-[2px] text-[#0d3f63]">{{ exchangeName }}</span>
          </span>
          {{ applyIbMessage.after }}
        </p>
        <button
          type="button"
          class="mt-[40px] flex h-[46px] w-[184px] cursor-pointer items-center justify-center rounded-[100px] bg-[#433269] px-[20px] py-[12px] text-[14px] leading-[22px] font-[600] text-[#fff1cb] hover:bg-[#51407a]"
          @click="closeDialog"
        >
          {{ t('83585') }}
        </button>
      </div>
    </div>
  </ElDialog>
</template>

<style scoped lang="less">
:global(.ib-apply-dialog) {
  overflow: hidden;
  border-radius: 28px;
  background: #fff;
  padding: 0;
}

:global(.ib-apply-dialog .el-dialog__header) {
  display: none;
  padding: 0;
  margin: 0;
}

:global(.ib-apply-dialog .el-dialog__body) {
  padding: 0;
}
</style>
